<template>
  <b-modal
    v-if="showModalData"
    v-model="modalBoostFlow"
    centered
    hide-header-close
    hide-footer
    hide-header
    size="sm"
    body-class="boost-body"
    content-class="boost-content"
  >
    <div
      class="cursor-pointer fw-700"
      style="position: absolute; top: 12px; right: 16px; z-index: 3; color: #FFBFD9; font-size: 18px"
      @click="modalBoostFlow = false"
    >
      x
    </div>
    <div class="boost-header">
      <img
        src="@/assets/images/paywall/boost-header.png"
        class="w-100"
      />
    </div>
    <div class="boost-inner">
      <h2 class="boost-header-title">
        {{ showModalData.header_title || showModalData.popupHeader }}
      </h2>

      <div class="boost-image">
        <img src="@/assets/images/paywall/boost-profile-bg.png" width="180">
        <b-avatar
          size="88"
          :src="profileImage"
          variant="light-primary"
          class="boost-avatar"
        >
          <feather-icon
            v-if="!profileImage"
            icon="UserIcon"
            size="88"
          />
        </b-avatar>
      </div>

      <div class="boost-username">
        <img src="@/assets/images/paywall/boost-username-bg.png" width="280">
        <p class="boost-username-text">
          {{ userName }}
        </p>
      </div>

      <p class="boost-title">
        {{ showModalData.title }}
      </p>

      <div v-if="showModalData.content" class="boost-features">
        <div v-for="(feature, index) in showModalData.content.split(',')" :key="index" class="boost-feature">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10" cy="10" r="10" fill="#19E286"/>
            <path d="M13.9385 7.35742C14.1248 7.35742 14.31 7.41108 14.4668 7.53223L14.5322 7.58789L14.5918 7.65137C14.7227 7.80453 14.7861 7.99219 14.7861 8.1875C14.7861 8.41072 14.7038 8.62396 14.5332 8.78711L14.5322 8.78809L10.0537 13.0566C9.85172 13.25 9.5973 13.3574 9.3125 13.3574C9.02725 13.3574 8.77248 13.2495 8.57031 13.0557L8.54492 13.0312L8.52441 13.0049L6.14551 10.001C5.99966 9.84402 5.92871 9.64728 5.92871 9.44141C5.92875 9.21921 6.00986 9.00762 6.17773 8.84473L6.24316 8.78711C6.40053 8.66326 6.58786 8.60858 6.77637 8.60938C6.98836 8.61032 7.19863 8.68095 7.36719 8.84082L7.39453 8.86719L7.41797 8.89648L9.36621 11.4053L13.3447 7.5918V7.59082C13.5132 7.42868 13.7247 7.3575 13.9385 7.35742Z" fill="white" stroke="white"/>
          </svg>
          {{ feature }}
        </div>
      </div>
      <div v-if="showModalData.popupSubtitle" class="boost-features">
        <div v-for="(feature, index) in showModalData.popupSubtitle.split(',')" :key="index" class="boost-feature">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10" cy="10" r="10" fill="#19E286"/>
            <path d="M13.9385 7.35742C14.1248 7.35742 14.31 7.41108 14.4668 7.53223L14.5322 7.58789L14.5918 7.65137C14.7227 7.80453 14.7861 7.99219 14.7861 8.1875C14.7861 8.41072 14.7038 8.62396 14.5332 8.78711L14.5322 8.78809L10.0537 13.0566C9.85172 13.25 9.5973 13.3574 9.3125 13.3574C9.02725 13.3574 8.77248 13.2495 8.57031 13.0557L8.54492 13.0312L8.52441 13.0049L6.14551 10.001C5.99966 9.84402 5.92871 9.64728 5.92871 9.44141C5.92875 9.21921 6.00986 9.00762 6.17773 8.84473L6.24316 8.78711C6.40053 8.66326 6.58786 8.60858 6.77637 8.60938C6.98836 8.61032 7.19863 8.68095 7.36719 8.84082L7.39453 8.86719L7.41797 8.89648L9.36621 11.4053L13.3447 7.5918V7.59082C13.5132 7.42868 13.7247 7.3575 13.9385 7.35742Z" fill="white" stroke="white"/>
          </svg>
          {{ feature }}
        </div>
      </div>

      <div class="boost-button">
        <div @click="buyProduct({banner: showModalData, name: 'buy', params: {productId: 'com.arasana.app.50DK', purchaseSource: 'premium-popup-5000'} })">
          <b-button
            class="mt-2 mb-1 btn-primary2 w-100"
            type="submit"
            variant="primary"
            block
          >
            {{ $t('Become Premium') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import {
  BAvatar, BButton, BModal,
} from 'bootstrap-vue'

export default {
  components: {
    BAvatar,
    BButton,
    BModal,
  },
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
    showModalData: {
      default: () => ({}),
      required: true,
    },
    modalModel: {
      type: Boolean,
      default: false,
      required: true,
    },
    userName: {
      type: String,
      default: '',
      required: true,
    },
    profileImage: {
      type: String,
      default: '',
      required: true,
    },
  },
  data() {
    return {
      modalBoostFlow: this.modalModel,
    }
  },
  watch: {
    modalModel(val) {
      this.modalBoostFlow = val
    },
    modalBoostFlow(val) {
      this.$emit('update:modalModel', val)
    },
  },
  methods: {
    buyProduct(product) {
      if (this.mobile) {
        if (window.webkit) {
          if (window.webkit.messageHandlers && window.webkit.messageHandlers.iosListener) {
            // eslint-disable-next-line radix
            window.webkit.messageHandlers.iosListener.postMessage({
              key: 'buy-button',
              params: {
                id: product.banner.iosProduct,
              },
            })
          }
        }
        if (window.AndroidApp) {
          // eslint-disable-next-line radix
          window.AndroidApp.sendData(JSON.stringify({
            key: 'buy-button',
            params: {
              id: product.banner.androidProduct,
            },
          }))
        }
      } else {
        this.$router.push({
          name: product.name,
          params: product.params,
          query: product.query,
        })
      }
    },
  },
}
</script>

<style lang="scss">
.boost-content {
  overflow: hidden !important;
  border-radius: 32px;

  .boost-body {
    padding: 0 !important;
    margin: 0 !important;

    .boost-header {
      width: 100%;
      margin-top: -20px;
      z-index: 1;
      position: absolute;
      left: 0;
      top: 0;
    }

    .boost-inner {
      position: relative;
      display: flex;
      flex-direction: column;
      z-index: 2;
      justify-content: center;
      align-items: center;

      .boost-header-title {
        font-family: Poppins, sans-serif !important;
        font-size: 20px;
        font-weight: 700;
        color: #fff;
        text-align: center;
        padding: 0 24px;
        margin-top: 16px;
      }

      .boost-title {
        font-family: Poppins, sans-serif !important;
        font-size: 16px;
        font-weight: 700;
        color: #272727;
        text-align: center;
        padding: 0 24px;
        margin-top: 16px;
      }

      .boost-image {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;

        .boost-avatar {
          position: absolute;
          top: 55%;
          left: 50%;
          transform: translate(-50%, -50%);

          /* Görsel stiller */
          width: 88px;
          height: 88px;
          background-color: dodgerblue;
          border-radius: 50%;
        }
      }

      .boost-username {
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        margin-top: -32px;

        .boost-username-text {
          position: absolute;
          display: flex;
          top: 26px;
          justify-content: center;
          z-index: 3;
          font-family: Poppins, sans-serif !important;
          font-size: 20px;
          font-weight: 700;
          color: #fff;
          text-align: center;
          width: 180px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;

          /* --- İşte Sihirli Kısım --- */
          text-shadow:
              1px 0 5px #7B390066,
              -1px 0 5px #7B390066,
              0 1px 5px #7B390066,
              0 -1px 5px #7B390066,
              0 3px 2px #6B000080;
        }
      }

      .boost-features {
        display: flex;
        justify-content: center;
        flex-direction: column;
        width: 100%;
        gap: 10px;
        padding: 0 18px;
        margin-top: 12px;

        .boost-feature {
          color: #CC1BA5;
          font-family: Poppins, sans-serif !important;
          font-size: 17px;
          font-weight: 500;
          display: flex;
          align-items: center;
          gap: 14px;
        }
      }

      .boost-button {
        width: 100%;
        padding: 0 24px;
        margin-top: 8px;
        margin-bottom: 12px;
      }
    }
  }
}
</style>
